import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { StompClient } from "@/service/StompClient";

export interface SocketState {
  socket: StompClient;
  connectionStarted: boolean;
  pendingCallbacks: Array<() => void>;
}

const initialState: SocketState = {
  socket: new StompClient(),
  connectionStarted: false,
  pendingCallbacks: []
};

const actions: ActionTree<SocketState, any> = {
  connect({ commit }: ActionContext<SocketState, any>, payload?: any): void {
    commit("connect", payload);
  },
  disconnect({ commit }: ActionContext<SocketState, any>): void {
    commit("disconnect");
  }
};

const mutations = {
  connect(state: SocketState, payload?: any) {
    if (state.socket.isConnected()) {
      if (payload) { payload(); }
      return;
    }
    if (payload) { state.pendingCallbacks.push(payload); }
    // 自動再接続中も二重にconnectを開始しない。
    if (state.connectionStarted) { return; }
    state.connectionStarted = true;
    state.connectionStarted = state.socket.connect(() => {
      const callbacks = state.pendingCallbacks.splice(0);
      callbacks.forEach(callback => {
        try { callback(); } catch (err) { console.error(err); }
      });
    });
  },
  disconnect(state: SocketState) {
    state.connectionStarted = false;
    state.pendingCallbacks = [];
    // 切断中でも自動再接続の予約を停止する。
    state.socket.disconnect();
  }
};

const getters: GetterTree<SocketState, any> = {
  socket(state: SocketState): StompClient {
    return state.socket;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
